export default __webpack_public_path__ + "static/large-cabin-outside2-ffb91ffc1082f39c24f31bce5af60f64.jpg";